module.exports = __webpack_public_path__ + "static/sport/tag-login.45c6c55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport3/tag-login.png
// module id = 2s1T
// module chunks = 0